var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('About'),_c('plant'),_c('Ad'),_c('milestone'),_c('Market'),_c('Certification'),_c('Video')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }